/* eslint-disable react/prop-types */
import React from 'react';
import { Button, Col, DatePicker, Divider, Empty, Form, Input, List, Radio, Row } from 'antd';
import moment from 'moment';

function HolidaySettings({
  loading,
  newHolidayList,
  submitHoliday,
  setScreenModified,
  formHoliday,
  fieldsPermissions,
}) {
  const hasHolidayPermissions = fieldsPermissions?.Holiday.access !== 0;

  if (!hasHolidayPermissions)
    return (
      <div style={{ height: 100, width: '100%' }}>
        <Empty description="Nenhuma configuração de feriados disponível" />
      </div>
    );

  const handleAdd = async () => {
    const values = await formHoliday.validateFields();
    submitHoliday(values);
  };

  return (
    <Form
      form={formHoliday}
      disabled={loading}
      name="settingsFormHoliday"
      layout="vertical"
      autoComplete="off"
      onChange={() => setScreenModified(true)}
      style={{ marginBottom: 32 }}
    >
      <Row gutter={[24]}>
        <Col span={24}>
          <Divider className="configuration-divider" orientation="left">
            Feriados e Pontos Facultativos
          </Divider>
        </Col>

        <Col span={12}>
          <Col span={24}>
            <Form.Item
              name="holidayDate"
              label="Data"
              rules={[
                {
                  required: true,
                  message: 'Campo obrigatório!',
                },
              ]}
            >
              <DatePicker
                format="DD/MM/YYYY"
                style={{
                  borderRadius: 16,
                }}
              />
            </Form.Item>
          </Col>

          <Col span={24}>
            <Form.Item
              label="Nome"
              name="holidayName"
              rules={[
                {
                  required: true,
                  message: 'Campo obrigatório!',
                },
              ]}
            >
              <Input />
            </Form.Item>
          </Col>

          <Col span={12}>
            <Form.Item
              label="Nível"
              name="holidayLevel"
              rules={[
                {
                  required: true,
                  message: 'Campo obrigatório!',
                },
              ]}
            >
              <Radio.Group
                options={[
                  { label: 'Nacional', value: 'nacional' },
                  { label: 'Municipal', value: 'municipal' },
                ]}
                optionType="button"
              />
            </Form.Item>
          </Col>

          <Col span={12}>
            <Form.Item
              label="Tipo"
              name="holidayType"
              rules={[
                {
                  required: true,
                  message: 'Campo obrigatório!',
                },
              ]}
            >
              <Radio.Group
                options={[
                  { label: 'Feriado', value: 'feriado' },
                  { label: 'Facultativo', value: 'facultativo' },
                ]}
                optionType="button"
              />
            </Form.Item>
          </Col>

          <Col span={24}>
            <Button type="primary" block htmlType="button" onClick={handleAdd}>
              Adicionar
            </Button>
          </Col>
        </Col>
        <Col span={12}>
          <List
            bordered
            style={{ borderRadius: 28 }}
            dataSource={newHolidayList}
            renderItem={(item) => {
              const date = moment(new Date(item.date)).format('DD/MM/YYYY');

              return (
                <List.Item key={item.name} style={{ padding: 12 }}>
                  {date} | {item.name} | {item.level} | {item.type}
                </List.Item>
              );
            }}
          />
        </Col>
      </Row>
    </Form>
  );
}

export default HolidaySettings;
